import React, { useRef } from "react";
import { useSelector } from "react-redux";

import { useProfileState } from "../../../hooks/useProfileState";
import MaterialTable from "@material-table/core";
import UserService from "../../../services/UserService";
import { header } from'../../../shared/headerStyle';
import {useNavigate} from "react-router-dom";
import {buildRealmPath} from "../../../shared/routing";
import BimProfileService from "../../../services/BimProfileService";

const TOOLBAR_HEIGHT = 74;
const PAGINATION_HEIGHT = 52;
const BORDER = 1;

function BimetaProfilesListView({ profileList, GetProfilesData, addNew }) {
    const tableRef = useRef();
    const token = useSelector((state) => state.keycloakToken);
    const realm = useSelector((state) => state.theRealm);
    const profile = useProfileState();
    const setBimProf = profile.setProfiles;

    const navigate = useNavigate();
    const tableHeight = (window.innerHeight - TOOLBAR_HEIGHT - PAGINATION_HEIGHT - BORDER) / window.innerHeight * 100;

    const GetLocalProfileData = async () => {
        try {
            const res = await BimProfileService.getBimProfiles(token, realm);
            setBimProf(res.data);
        } catch (e) {
            console.error("Fehler beim Laden der Profile:", e);
        }
    };

    const showProfileList = async () => {
        await GetLocalProfileData();
        navigate(buildRealmPath(realm, '/BimProfile'));
    };

    return (
        <>
            <MaterialTable
                tableRef={tableRef}
                title="Profile"
                columns={[
                    { title: 'Bezeichnung', field: 'name' },
                    { title: 'Kategorie', field: 'lifeCyclePhase' },
                    { title: 'Kennzeichen', field: 'identifier' },
                ]}
                data={profileList}
                options={{
                    headerStyle: header,
                    actionsColumnIndex: -1,
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 50, 100],
                    exportButton: true,
                    exportAllData: true,
                    maxBodyHeight: `${tableHeight}vh`,
                    minBodyHeight: `${tableHeight}vh`,
                }}
                actions={[
                    {
                        icon: 'input',
                        tooltip: 'BiMeta-Profil importieren',
                        onClick: (event, rowData) => addNew(rowData),
                        disabled: !UserService.hasRole(['ADMIN_MAP', 'MAP_ADMIN'])
                    },
                    {
                        icon: 'list',
                        tooltip: 'zurück zur Profil-Liste',
                        isFreeAction: true,
                        onClick: () => showProfileList(),
                    }
                ]}
                localization={{
                    pagination: {
                        labelDisplayedRows: '{from}-{to} von {count}',
                        labelRowsSelect: 'Zeilen',
                        labelRowsPerPage: 'Zeilen pro Seite'
                    },
                    toolbar: {
                        nRowsSelected: '{0} Zeile(n) ausgewählt',
                        searchTooltip: 'Suchen',
                        searchPlaceholder: 'Suchbegriff eingeben'
                    },
                    header: {
                        actions: ''
                    },
                    body: {
                        emptyDataSourceMessage: 'Keine Einträge gefunden',
                        filterRow: {
                            filterTooltip: 'Filter'
                        },
                        editRow: {
                            deleteText: 'Soll der Datensatz wirklich gelöscht werden?',
                            saveTooltip: 'Speichern',
                            cancelTooltip: 'Abbrechen'
                        }
                    }
                }}
            />
        </>
    );
}

export default BimetaProfilesListView;
